<template>
	<main>
		<HeaderTab :title="$t('global.titre_tiers_search')"  :swiper_tabs="swiper_tabs" :return_action="'navigationBack'"/>
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div>	
							<div>
                        		<router-view></router-view>
                    		</div>
                    	</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">

import Navigation from "@/mixins/Navigation.js";

export default {
	name: "TiersSearch",
	mixins: [Navigation],
	data () {
		return {
			param_tab: '',
			actual_tab: 'tiersSearchQualification',
			swiper_tabs: [],
		}
	},
	mounted() {
            this.param_tab = this.$route.params.actual_tab

			this.swiper_tabs = [
				{
					id: 'search',
					label: 'tiers.tiers_search',
					active: true,
					href : 'tiersSearchQualification'
				},
				{
					id: 'tiersSearchDuplicate',
					label: 'tiers.tiers_search_duplicate',
					active: false,
					href : 'tiersSearchDuplicate'
				}
			]
		},
	methods: {
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		SearchQualification : () => import('@/components/Qualification/SearchQualification'),
	}
}
</script>
